module.exports = __webpack_public_path__ + "static/media/29DUNON7.92e38679.jpg";